import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { PositionCustody } from 'src/app/shared/interfaces/position-custody';

import { PositionConsultListComponent } from './position-consult-list/position-consult-list.component';
import { PositionConsultListService } from './shared/position-consult-list.service';
import { countActiveFilters } from './shared/position-consult.utils';

@Component({
  standalone: false,
  selector: 'app-position-consult',
  templateUrl: './position-consult.component.html',
  styleUrls: ['./position-consult.component.scss'],
})
export class PositionConsultComponent implements OnInit, OnDestroy {
  @ViewChild(PositionConsultListComponent)
  private listComponent?: PositionConsultListComponent;

  private readonly destroy$ = new Subject<void>();

  showFilter = false;
  showDetailsDrawer = false;
  selectedPositionForDetails: PositionCustody | null = null;
  filtersTotal = 0;
  valueTotal = 0;
  showLoadErrorBanner = false;
  showFilterUpdateNotice = false;
  isErrorModalOpen = false;
  errorModalMessage = 'Não foi possível concluir a operação. Tente novamente.';

  constructor(
    private readonly positionConsultListService: PositionConsultListService,
  ) {}

  get filterButtonAriaLabel(): string {
    if (this.filtersTotal <= 0) {
      return 'Filtrar';
    }

    return this.filtersTotal === 1
      ? 'Filtrar, 1 filtro aplicado'
      : `Filtrar, ${this.filtersTotal} filtros aplicados`;
  }

  get positionsFoundLabel(): string {
    return this.listComponent?.positionsFoundLabel
      ?? 'Aplique um filtro para consultar a posição';
  }

  ngOnInit(): void {
    this.positionConsultListService.filters
      .pipe(takeUntil(this.destroy$))
      .subscribe((filters) => {
        this.filtersTotal = countActiveFilters(filters);
        this.showFilterUpdateNotice = this.filtersTotal > 0;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onValueFilterTotal(value: number): void {
    this.filtersTotal = value;
  }

  onValueTotal(value: number): void {
    this.valueTotal = value;
    this.showLoadErrorBanner = false;
  }

  openAdvancedFilter(): void {
    this.showFilter = true;
  }

  onFilterDrawerClosed(): void {
    this.showFilter = false;
  }

  onFilterNoticeDismiss(): void {
    this.showFilterUpdateNotice = false;
  }

  onFilterNoticeUndo(): void {
    this.positionConsultListService.setFilters({});
    this.showFilterUpdateNotice = false;
  }

  openDetail(position: PositionCustody): void {
    if (!position?.carbonCreditCode?.trim()) {
      return;
    }

    this.selectedPositionForDetails = position;
    this.showDetailsDrawer = true;
  }

  onDetailsDrawerClosed(): void {
    this.showDetailsDrawer = false;
    this.selectedPositionForDetails = null;
  }

  onListLoadFailed(): void {
    this.showLoadErrorBanner = true;
  }

  onLoadErrorDismiss(): void {
    this.showLoadErrorBanner = false;
  }

  onLoadErrorRetry(): void {
    this.showLoadErrorBanner = false;
    this.listComponent?.reloadCurrentQuery();
  }

  onErrorModalClosed(): void {
    this.isErrorModalOpen = false;
  }

  private openErrorModal(message: string): void {
    this.errorModalMessage = message;
    this.isErrorModalOpen = true;
  }
}
